import { Route } from '@angular/router';
import { RoutePath } from '@univacity/shared/types';
import { ProgramResolver } from './resolvers/program.resolver';

export const programRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'search',
  },
  {
    path: RoutePath.search,
    loadComponent: () =>
      import(
        './search-page/program-search-page/program-search-page.component'
      ).then((m) => m.ProgramSearchPageComponent),
  },
  {
    path: `:id`,
    resolve: {
      program: ProgramResolver,
    },
    loadComponent: () =>
      import(
        './detail-page/program-detail-page/program-detail-page.component'
      ).then((m) => m.ProgramDetailPageComponent),
  },
];
